module.exports = __webpack_public_path__ + "img/seal-hunting-docks.b2e3b3e5.webp";